import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SweetAlertService {

  constructor() { }

  successModal(title: string, showCancelButton?:boolean, mensaje?:string, nameConfirButton?: string, nameCancelButton?: string) {
    return Swal.fire({
      title,
      showCancelButton:showCancelButton,
      icon: 'success',
      text:mensaje,
      confirmButtonText: nameConfirButton || 'Aceptar',
      cancelButtonText: nameCancelButton || 'Cancelar',
      allowOutsideClick: false
    });
  }

  errorModal(title: string, showCancelButton?:boolean, mensaje?:string, nameConfirButton?: string) {
    return Swal.fire({
      title,
      showCancelButton:showCancelButton,
      icon: 'error',
      text: mensaje,
      confirmButtonText: nameConfirButton || 'Aceptar',
      cancelButtonText: 'Cancelar',

    });
  }

  questionModal(title: string, showCancelButton?:boolean, mensaje?:string) {
    Swal.fire({
      title,
      showCancelButton:showCancelButton,
      icon: 'question',
      text: mensaje,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar',
    });
  }

  infoModal(title: string, showCancelButton?:boolean, mensaje?:string) {
    return Swal.fire({
      title,
      showCancelButton:showCancelButton,
      icon: 'info',
      text:mensaje,
      confirmButtonText: 'Aceptar',
      allowOutsideClick: false
    });
  }

  /**
   * Modal de registro exitoso (persona natural): mismo contenido y estilo que el diseño,
   * con fondo borroso (backdrop blur). Retorna la promesa para navegar al cerrar.
   */
  registroExitosoModal(mensaje?: string) {
    const html = mensaje ?? `Hemos <strong>enviado un correo electrónico a tu buzón registrado</strong>, ingresa y sigue las instrucciones.<hr class="registro-exitoso-swal-hr">Si no encuentras el correo, revisa también tu carpeta de spam.`;
    return Swal.fire({
      title: '¡Proceso finalizado con éxito!',
      html: `<div class="registro-exitoso-swal-text">${html}</div>`,
      icon: 'success',
      showCloseButton: true,
      showCancelButton: false,
      confirmButtonText: 'Cerrar',
      allowOutsideClick: false,
      buttonsStyling: false,
      customClass: {
        popup: 'registro-exitoso-swal',
        confirmButton: 'registro-exitoso-swal-btn',
        closeButton: 'registro-exitoso-swal-close'
      }
    });
  }
}
